<template>
  <div>
    <!-- Floating Action Button -->
    <button
        v-if="enableAI && analysisSummary"
        class="btn btn-primary rounded-circle shadow-lg position-fixed d-flex flex-column align-items-center justify-content-center"
        style="width: 90px; height: 90px; bottom: 30px; right: 30px; z-index: 1050; font-size: 16px; background: #7914a8; border: none;"
        @click="showPopup = true"
    >
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C11.2044 2 10.4413 2.31607 9.87868 2.87868C9.31607 3.44129 9 4.20435 9 5V5.29C6.89 6.15 5.5 8.27 5.5 10.5V16L4.5 17V18H19.5V17L18.5 16V10.5C18.5 8.27 17.11 6.15 15 5.29V5C15 4.20435 14.6839 3.44129 14.1213 2.87868C13.5587 2.31607 12.7956 2 12 2ZM12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22Z" fill="currentColor"/>
      </svg>
      <span style="font-size: 14px;">Open<br>Popup</span>
    </button>

    <!-- Popup Modal -->
    <div v-if="showPopup"
         class="modal d-block"
         tabindex="-1"
         role="dialog">
      <div class="modal-dialog" role="document" style="margin: 0;">
        <div
          class="modal-content p-0 responsive-popup"
          style="border-radius: 18px; max-width: 480px; position: fixed; right: 130px; bottom: 30px; height: 70vh; max-height: 70vh; overflow-y: auto; border: 2px solid #a084e8; box-shadow: 0 4px 24px rgba(80, 0, 120, 0.10);"
        >
          <!-- Header -->
          <div style="background: #f7f8fc; border-radius: 16px 16px 0 0; padding: 24px 28px 18px 28px; border-bottom: 1px solid #e5e0fa; position: relative;">
            <div style="display: flex; align-items: flex-start; justify-content: space-between;">
              <div style="display: flex; align-items: center; gap: 10px;">
                <!-- Sparkle/star icon -->
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 2.5L12.4721 7.02786C12.6272 7.48441 13.0156 7.87277 13.4721 8.02786L18 9.5L13.4721 10.9721C13.0156 11.1272 12.6272 11.5156 12.4721 11.9721L11 16.5L9.52786 11.9721C9.37277 11.5156 8.98441 11.1272 8.52786 10.9721L4 9.5L8.52786 8.02786C8.98441 7.87277 9.37277 7.48441 9.52786 7.02786L11 2.5Z" fill="#a084e8"/>
                </svg>
                <span style="font-weight: 600; color: #6c4bb6; font-size: 1.08rem;">AI Overview</span>
              </div>
              <button
                type="button"
                class="d-inline-flex align-items-center justify-content-center"
                @click="showPopup = false"
                aria-label="Close"
                style="width: 36px; height: 36px; border-radius: 50%; background: #fff; border: 1px solid #e5e0fa; color: #a084e8; font-size: 1.5rem; position: absolute; top: 18px; right: 18px; box-shadow: 0 1px 4px rgba(160, 132, 232, 0.08);"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div style="margin-top: 18px;">
              <div style="font-size: 1.45rem; font-weight: 700; color: #181a2a; line-height: 1.2;">{{ title }}</div>
              <div style="font-size: 1.02rem; color: #6c6f7c; margin-top: 2px;">
                {{ date }} <span style="margin: 0 6px;">•</span> <span>Source: {{ source }}</span>
              </div>
            </div>
          </div>
          <!-- Body -->
          <div style="padding: 28px 28px 18px 28px; background: #fff; border-radius: 0 0 16px 16px;">
            <div v-if="keyHighlights && keyHighlights.length > 0" class="mt-2">
              <div style="font-weight: 700; font-size: 1.08rem; color: #181a2a; margin-bottom: 10px; letter-spacing: 0.01em;">KEY HIGHLIGHTS</div>
              <ul class="pl-3" style="list-style-type: disc; color: #181a2a; font-size: 1.08rem; margin-bottom: 18px;">
                <li v-for="highlight in keyHighlights" :key="highlight" class="mb-2">{{ highlight }}</li>
              </ul>
            </div>
            <div style="padding-top: 16px;">
              <div style="font-weight: 700; font-size: 1.08rem; color: #181a2a; margin-bottom: 10px; letter-spacing: 0.01em;">SUMMARY</div>
              <div style="font-size: 1.13rem; color: #181a2a; margin-bottom: 18px;">{{ analysisSummary }}</div>
              <div v-if="pressReleaseUrl">
                <a :href="pressReleaseUrl" target="_blank" style="color: #3bb3c3; font-weight: 500; font-size: 1.08rem; text-decoration: underline;">View Full Press Release</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIAnalysisPopup',
  props: {
    title: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    source: {
      type: String,
      required: true
    },
    analysisSummary: {
      type: String,
      required: true
    },
    keyHighlights: {
      type: Array,
      default: () => []
    },
    enableAI: {
      type: Boolean
    },
    pressReleaseUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showPopup: false
    }
  }
}
</script>

<style>
@media (max-width: 576px) {
  .responsive-popup {
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    max-width: 100vw !important;
    width: 100vw !important;
    border-radius: 10px 10px 0 0 !important;
    height: 60vh !important;
    min-height: 40vh;
    border: 2px solid #a084e8 !important;
  }
}

/* Hide vertical scrollbar for modal-content but allow scrolling */
.modal-content {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE 10+ */
}
.modal-content::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
</style> 
